import axios from "./httpService";
import { store } from "../../redux/store";
import { handleLogout } from "../../redux/authentication";
import history from "./history";

class Repository {
    async findByEndPoint(location) {
        try {
            const response = await axios.get(`${location}`);
            return response;
        } catch (error) {
            if (error.response?.statusText == "Unauthorized") {
                store.dispatch(handleLogout());
                history.push("/login");
            }
            return error;
        }
    }

    async postRequest(location, payload) {
        try {
            const response = await axios.post(location, payload);
            return response;
        } catch (error) {
            if (error.response?.statusText == "Unauthorized") {
                store.dispatch(handleLogout());
                history.push("/login");
            }
            return error;
        }
    }

    async putRequest(location, payload) {
        const response = await axios.put(location, payload);
        return response;
    }

    async updateData(location, payload) {
        const response = await axios.patch(location, payload);
        return response;
    }

    async deleteById(location) {
        try {
            const response = await axios.delete(location);
            return response;
        } catch (error) {
            if (error.response?.statusText == "Unauthorized") {
                store.dispatch(handleLogout());
                history.push("/login");
            }
            return error;
        }
    }

    async deleteData(location, payload) {
        try {
            const response = await axios.delete(location, {
                data: payload,
            });
            return response;
        } catch (error) {
            if (error.response?.statusText == "Unauthorized") {
                store.dispatch(handleLogout());
                history.push("/login");
            }
            return error;
        }
    }
}
export default new Repository();
